import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ConfirmationModal, Typography } from 'seagull';
import ExternalLinkButton from '~/components/ExternalLinkButton';
import { useOverlayContext, useStoreActions } from '~/contexts';
import { helpArticles } from '~/utils/helpArticles';
export function useRequestPM() {
    const overlayContext = useOverlayContext();
    const { api, logBI } = useStoreActions();
    return async function requestPaymentMethod(agreementId) {
        const confirmed = await overlayContext.showModal({
            content: (param)=>{
                let { dismissModal } = param;
                return /*#__PURE__*/ _jsx(ConfirmationModal, {
                    title: "Request Payment Method",
                    testId: "request-pm-modal",
                    textAlignCenter: false,
                    content: /*#__PURE__*/ _jsxs("div", {
                        children: [
                            /*#__PURE__*/ _jsx(Typography, {
                                children: "Once you send a request, your client will receive an email asking them to set up their payment details in Anchor."
                            }),
                            /*#__PURE__*/ _jsx("br", {}),
                            /*#__PURE__*/ _jsx(Typography, {
                                children: "Consider sending a personal message to clients still transitioning to Anchor to communicate the purpose of this request."
                            }),
                            /*#__PURE__*/ _jsx("br", {}),
                            /*#__PURE__*/ _jsx(ExternalLinkButton, {
                                openInNewTab: true,
                                underline: "none",
                                href: helpArticles.requestPaymentMethod(),
                                children: "Learn more about Request Payment Method"
                            })
                        ]
                    }),
                    primaryButtonLabel: "Send Request",
                    primaryButtonTestId: "confirmation-modal-primary-btn",
                    secondaryButtonLabel: "Cancel",
                    onPrimaryButtonClick: ()=>dismissModal(true),
                    onSecondaryButtonClick: ()=>dismissModal(false)
                });
            }
        });
        if (confirmed) {
            logBI(11253);
            overlayContext.startLoader('request-pm-loader');
            try {
                await api.relationship.requestPaymentMethod(agreementId);
                overlayContext.showSuccessToast('Payment method request sent', 'request-pm-success-toast');
            } catch (err) {
                overlayContext.showErrorToast('Failed to request payment method', 'request-pm-error-toast');
            } finally{
                overlayContext.stopLoader('request-pm-loader');
            }
        }
    };
}
